var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3944_8801)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3944_8801",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0H0V35H35V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3944_8801)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83501 27.165 0 17.5 0C7.83501 0 0 7.83501 0 17.5C0 27.165 7.83501 35 17.5 35Z",
    fill: "#FCE0A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3495 20.4658C17.0064 20.4658 18.6626 20.4673 20.3193 20.4648C20.9418 20.4636 21.3548 19.8984 21.1433 19.3391C21.0147 18.999 20.7549 18.8242 20.398 18.7896C20.3331 18.7832 20.2674 18.7865 20.2019 18.7865C16.9539 18.7865 13.7064 18.7859 10.4585 18.7885C10.3162 18.7885 10.1673 18.7974 10.0328 18.8389C9.64245 18.9591 9.41729 19.3469 9.47606 19.7651C9.53007 20.1499 9.87544 20.4574 10.2821 20.4642C10.7403 20.472 11.199 20.4663 11.6571 20.4668C12.8872 20.4663 14.1184 20.4658 15.3495 20.4658Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3148 10.4059C13.6517 10.4059 11.9886 10.4048 10.325 10.4064C9.94511 10.4069 9.63966 10.6153 9.5148 10.949C9.39457 11.2697 9.47015 11.6518 9.74305 11.8585C9.89157 11.9708 10.0926 12.0165 10.2736 12.0805C10.3319 12.101 10.4032 12.0858 10.4689 12.0858C13.71 12.0858 16.9511 12.0868 20.1922 12.0837C20.3407 12.0837 20.4966 12.0726 20.6362 12.0275C21.0271 11.901 21.2455 11.5101 21.1798 11.0939C21.1216 10.7255 20.7868 10.4295 20.4016 10.4075C20.3365 10.4038 20.271 10.4059 20.2053 10.4059C18.5758 10.4059 16.9453 10.4059 15.3148 10.4059Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6613 16.2708C14.7676 16.2708 15.8734 16.2749 16.9796 16.2692C17.5857 16.2661 17.9835 15.7287 17.803 15.174C17.6928 14.8349 17.3905 14.6077 17.0158 14.6036C16.4071 14.5967 15.7983 14.6009 15.19 14.6009C13.58 14.6009 11.9699 14.5993 10.3598 14.6019C9.82982 14.6024 9.46818 14.9467 9.46875 15.4374C9.46922 15.8976 9.81506 16.2597 10.2843 16.2677C10.86 16.2776 11.4362 16.2708 12.0119 16.2714C12.5619 16.2708 13.1119 16.2708 13.6613 16.2708Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9079 28.2284C26.7694 28.2284 29.0891 25.9086 29.0891 23.047C29.0891 20.1855 26.7694 17.8657 23.9079 17.8657C21.0463 17.8657 18.7266 20.1855 18.7266 23.047C18.7266 25.9086 21.0463 28.2284 23.9079 28.2284Z",
    fill: "#18AB56",
    stroke: "#18AB56",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3944_8801",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 20,
    width: 6,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5469 22.6861V20.519H24.2694V22.6861H26.4364V23.4085H24.2694V25.5756H23.5469V23.4085H21.3799V22.6861H23.5469Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3944_8801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5475 22.6866V24.7677H25.6285V22.6866H23.5475ZM23.5475 20.5196V18.4385H21.4664V20.5196H23.5475ZM24.2699 20.5196H26.351V18.4385H24.2699V20.5196ZM24.2699 22.6866H22.1888V24.7677H24.2699V22.6866ZM26.437 22.6866H28.518V20.6055H26.437V22.6866ZM26.437 23.409V25.4901H28.518V23.409H26.437ZM24.2699 23.409V21.328H22.1888V23.409H24.2699ZM24.2699 25.5761V27.6572H26.351V25.5761H24.2699ZM23.5475 25.5761H21.4664V27.6572H23.5475V25.5761ZM23.5475 23.409H25.6285V21.328H23.5475V23.409ZM21.3804 23.409H19.2993V25.4901H21.3804V23.409ZM21.3804 22.6866V20.6055H19.2993V22.6866H21.3804ZM25.6285 22.6866V20.5196H21.4664V22.6866H25.6285ZM23.5475 22.6006H24.2699V18.4385H23.5475V22.6006ZM22.1888 20.5196V22.6866H26.351V20.5196H22.1888ZM24.2699 24.7677H26.437V20.6055H24.2699V24.7677ZM24.3559 22.6866V23.409H28.518V22.6866H24.3559ZM26.437 21.328H24.2699V25.4901H26.437V21.328ZM22.1888 23.409V25.5761H26.351V23.409H22.1888ZM24.2699 23.495H23.5475V27.6572H24.2699V23.495ZM25.6285 25.5761V23.409H21.4664V25.5761H25.6285ZM23.5475 21.328H21.3804V25.4901H23.5475V21.328ZM23.4615 23.409V22.6866H19.2993V23.409H23.4615ZM21.3804 24.7677H23.5475V20.6055H21.3804V24.7677Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3944_8801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMoreIcon);
export default __webpack_public_path__ + "static/media/view_more_icon.1fd2ec1e774f8d659df758d0b561195d.svg";
export { ForwardRef as ReactComponent };